<ion-app [class.ui-mobile]="utilSvc.mobileViewActive">
    <app-mobile-menu></app-mobile-menu>
    <div id="main" [class.loggedin]="authSvc.isLoggedIn">
        <app-header></app-header>

        <div id="startup-loader-wrap" *ngIf="startupLoaderVisible">
            <div id="startup-loader-content">
                <ion-spinner name="crescent"></ion-spinner>
                <div>{{ 'public.site-loading' | translate }}</div>
            </div>
        </div>

        <div class="auth-device-lock">
            <div class="device-lock-info ion-text-center">
                <div [innerHTML]="'public.other-device-active.info' | translate"></div>
                <div
                    *ngIf="nextUnlockPossibleString != ''"
                    class="dp-mt-m ion-color-danger"
                    [innerHTML]="'public.other-device-active.locked-until' | translate: { time: nextUnlockPossibleString }"
                ></div>
                <ion-button class="dp-mt-m" (click)="unlockDevice()" size="large" [dpIsLoading]="unlockDeviceLoading">
                    <fa-icon icon="unlock" slot="start"></fa-icon>
                    {{ 'public.other-device-active.unlock-btn' | translate }}
                </ion-button>
            </div>
        </div>

        <ion-content scrollX="false" scrollY="false">
            <ion-router-outlet [animated]="utilSvc && utilSvc.mobileViewActive"></ion-router-outlet>
        </ion-content>
    </div>
</ion-app>
